module.exports = "/_next/static/images/banner-ec384113cf67d20dee0a099d08699108.jpg";